export default __webpack_public_path__ + "static/media/no_pass_bg.a0a13d1d.png";